import { render } from "./AdmMessageChat.vue?vue&type=template&id=b1f3bc44&scoped=true"
import script from "./AdmMessageChat.vue?vue&type=script&lang=js"
export * from "./AdmMessageChat.vue?vue&type=script&lang=js"

import "./AdmMessageChat.vue?vue&type=style&index=0&id=b1f3bc44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f3bc44"]])

export default __exports__